// @ts-nocheck
import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import Home from "../Body/Home";
import { ProvideBody } from "../Body/state/ProvideBody";


const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: "24px",
    }
}));

export default function Error()  {
    const classes = useStyles();
    return (
        <ProvideBody error={true}>
            <main className={classes.content}>
                <div className={classes.toolbar}/>
                        <Home error={true}/>
            </main>
        </ProvideBody>
    );
}